import produce from 'immer'

import {
  HOME_RECORDS_COUNT_LOAD,
  HOME_RECORDS_COUNT_LOAD_SUCCESS,
  HOME_RECORDS_COUNT_LOAD_FAILURE
} from './actions'

const DEFAULT_TIME_PERIOD_STATE = {
  loading: false,
  error: null,
  count: null
}

const DEFAULT_MODULE_STATE = {
  total: DEFAULT_TIME_PERIOD_STATE,
  today: DEFAULT_TIME_PERIOD_STATE,
  last30Days: DEFAULT_TIME_PERIOD_STATE,
  assignedToMe: DEFAULT_TIME_PERIOD_STATE
}

const initialState = {
  waste: DEFAULT_MODULE_STATE,
  delivery: DEFAULT_MODULE_STATE
}

const reducer = (state = initialState, action) => {
  let { moduleName } = action
  const { period } = action
  if (moduleName) {
    moduleName = moduleName.toLowerCase()
  }
  return produce(state, draft => {
    switch (action.type) {
      case HOME_RECORDS_COUNT_LOAD: {
        draft[moduleName][period].loading = true
        return
      }
      case HOME_RECORDS_COUNT_LOAD_SUCCESS: {
        draft[moduleName][period].loading = false
        draft[moduleName][period].error = null
        draft[moduleName][period].count = action.recordsCount.total
        return
      }
      case HOME_RECORDS_COUNT_LOAD_FAILURE: {
        draft[moduleName][period].loading = false
        draft[moduleName][period].error = action.error
        return
      }
    }
  })
}

export { reducer }
